import React from 'react';
import { DatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';

const { RangePicker } = DatePicker;

export type DateRange = [Dayjs, Dayjs];

export function defaultDateRange(days = 30): DateRange {
  const end = dayjs().endOf('day');
  const start = end.subtract(days - 1, 'day').startOf('day');
  return [start, end];
}

interface Props {
  value: DateRange;
  onChange: (range: DateRange) => void;
}

export function DateRangeFilter({ value, onChange }: Props): React.ReactElement {
  return (
    <RangePicker
      value={value}
      format="DD/MM/YYYY"
      allowClear={false}
      disabledDate={(d) => d.isAfter(dayjs(), 'day')}
      onChange={(dates) => {
        if (dates && dates[0] && dates[1]) {
          onChange([dates[0].startOf('day'), dates[1].endOf('day')]);
        }
      }}
    />
  );
}
